/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

freeGift();
ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    $('.ajaxcart__product').removeClass('active');
    $('.ajaxcart__product').removeClass('selected');
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      } 
      updateMainCart();   
      freeGift();
      setTimeout(function() {
        $(form).find(".dT_AddToCart").removeClass('loading');
        $(form).find(".dT_AddToCart").prop('disabled', false);
        $(form).find(".dT_AddToCart").addClass('is-added');
        $(form).find(".dT_AddToCart").text("Added")
        setTimeout (function() {
          $(form).find(".dT_AddToCart").removeClass('is-added');
          $(form).find(".dT_AddToCart").text("Add to Cart")
        }, 800)
      }, 500);
      if (window.innerWidth > 768) {
        var isHovered = false;
        var cartDrawer = $('#CartDrawer');
        setTimeout(function(){
          if (cartDrawer.is(':hover')) {
            isHovered = true;
            cartDrawer.each(function(e) {
              $(this)
                .mouseleave(function() {
                  setTimeout(function(){
                    $('.js-drawer-close').trigger('click');
                  }, 1000)
                });
            })
          } else {
            isHovered = false;
            $('.js-drawer-close').trigger('click');
          }
          updateMainCartOnPage();
        }, 3000)  
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      setTimeout(function() {
        $(form).find(".dT_AddToCart").removeClass('loading');
        $(form).find(".dT_AddToCart").prop('disabled', false);
      }, 800);
      if ((typeof errorCallback) === 'function') {
        // errorCallback(XMLHttpRequest, textStatus);
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $(form).find(".dT_AddToCart").removeClass('is-adding is-added');
        if (!!data.message) {
          if (data.status == 422) {
            if ($(form).find('.add-to-cart-group')) {
              var addButtoncontainer = $(form).find('.add-to-cart-group');
              var inventoryQuantity = $(addButtoncontainer).data('inventory-quantity');
              addButtoncontainer.after('<div class="errors qty-error">'+ `Oops! We only have `+ inventoryQuantity + ` items in stock for this product. Please adjust your quantity and try again.` +'</div>')
            }
            if($(form).find('.product-form__item--submit')) {
              var addMessageError = $(form).find('.product-form__item--submit');
              var inventoryQuantity = $(addMessageError).data('inventory-quantity');
              addMessageError.before('<div class="errors qty-error">'+ `Oops! We only have `+ inventoryQuantity +` items in stock for this product. Please adjust your quantity and try again.` +'</div>')
            }
          }
        }
        if ($(form).find('.add-to-cart-group').length != 0) {
          setTimeout(function(){
            $(form).find('.qty-error').remove();
            $(form).find(".quantity-btn-number").val(1);
          }, 2000)
        }
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

function freeGiftCartDrawer() {
  console.log('RUN FREE GIFT ON CART DRAWER');
  fetch("/cart.js")
  .then((response) => response.json())
  .then((cart) => {
    const GIFT_VARIANT_ID = window.FREE_GIFT_VARIANT_ID;
    const reloadFlag = "free_gift_added";
    const itemCarts = cart.items;
    let hasGift = itemCarts.find((item) => item.id === GIFT_VARIANT_ID);    
    let gift_threshold =  100;
    let convert_threshold =  parseInt(gift_threshold*100);
    if (cart.items_subtotal_price > convert_threshold && hasGift == undefined) {
      console.log("DA THEM GIFT");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: GIFT_VARIANT_ID,
          quantity: 1,
        }),
      })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then((data) => {
        console.log("added to cart", data);
        const item = data;
        const itemHTML = `
                          <li class="ajaxcart__product gift-product" data-id="${item.id}" data-product_id="${item.product_id}">
                            <div class="ajaxcart row" data-id="${item.id}">
                              <div class="cart-item-loading"></div>
                              <div class="item_img">
                                <a href="${item.url}" class="ajaxcart__product-image">
                                  <img src="${item.image}" alt="${item.title}">
                                </a>
                              </div>
                              <div class="details">
                                <h6>
                                  <a href="${item.url}" class="ajaxcart__product-name">${item.title}</a>
                                </h6>
                                <div class="item-desc ajaxcart-product__details">
                                  <div class="item_dtl" data-id="${item.id}">
                                    <div class="pricing">
                                      <span class="ajaxcart__price"><span class="money">$${item.presentment_price.toFixed(2)}</span></span>
                                    </div>
                                  </div>
                                <div class="ajaxcart__qty product-item-caption-qty">
                                FREE GIFT
                                </div>
                                </div>
                              </div>
                            </div>
                          </li>
        `;
        $("#CartCount .CartCount").html(parseInt(cart.item_count + 1));
        document.querySelector('.ajaxcart__inner')?.insertAdjacentHTML('beforeend', itemHTML);
        localStorage.setItem(reloadFlag, "true");
      }) 
      .catch((err) => {
        console.error("❌ Lỗi khi thêm vào giỏ:", err);
      });
    }
    if(cart.items_subtotal_price < convert_threshold && hasGift){
      console.log(GIFT_VARIANT_ID);
      console.log("Remove and hide item on the cart drawer");
      // Hide item on the cart drawer
      const giftElement = document.querySelector(`.ajaxcart__product[data-id="${GIFT_VARIANT_ID}"]`);
      $('.gift-product').hide();
      if (giftElement) {
        giftElement.classList.add('hidden');
        const giftLine = findKeyByVariantId(cart.items, GIFT_VARIANT_ID);
         console.log('giftLine' + giftLine);
        // Lấy line number từ thuộc tính data-line của phần tử
        if (giftLine) {
          const giftLineKey = giftLine;
          console.log('giftLineKey' + giftLineKey);
          console.log(typeof giftLineKey);
          // Gọi API để xóa sản phẩm quà tặng
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: giftLineKey,
              quantity: 0
            })
          })
        .then(response => response.json())
        .then(cart => {
          console.log("Đã xóa sản phẩm quà tặng");
          const last_threshold =  convert_threshold - parseInt(cart.items_subtotal_price);
            $('.title__success').hide();
            $('.title__left, .title__right').removeClass('is-hidden').show();
            const priceInDollars = (last_threshold / 100).toFixed(2);
            const formattedPrice = `$${priceInDollars}`;
            $('.title__right-price').html(formattedPrice);
            const progressPercentage = (cart.items_subtotal_price / convert_threshold) * 100;
            document.documentElement.style.setProperty('--my-end-width', `${progressPercentage}%`);
            console.log('Progress percentage: ' + progressPercentage + '%');
          if(cart.item_count != 0){
            $("#CartCount .CartCount").html(parseInt(cart.item_count - 1));
          }else{
            console.log('RUN KHI GIỎ HÀNG RỖNG');
            
            $("#CartCount .CartCount").html(parseInt(cart.item_count));
            $("#CartContainer").empty();
            $("#CartContainer").append('<p class="cart-content"> <span>No Products in your Cart.</span> <a class="dt-sc-btn" href="/collections/all">Continue Shopping</a></p>');
          }
        })
        .catch(error => {
          console.error("Lỗi khi xóa sản phẩm quà tặng:", error);
        });
        }
      } 
    }
    
    if(cart.items_subtotal_price < convert_threshold && hasGift == undefined){
      const last_threshold =  convert_threshold - parseInt(cart.items_subtotal_price);
      $('.title__success').hide();
      $('.title__left, .title__right').removeClass('is-hidden').show();
      const priceInDollars = (last_threshold / 100).toFixed(2);
      const formattedPrice = `$${priceInDollars}`;
      $('.title__right-price').html(formattedPrice);
      // Calculate progress percentage and update CSS variable
      const progressPercentage = (cart.items_subtotal_price / convert_threshold) * 100;
      document.documentElement.style.setProperty('--my-end-width', `${progressPercentage}%`);
      console.log('Progress percentage: ' + progressPercentage + '%');
    }else{
      $('.title__success').show();
      $('.title__left, .title__right').hide();
      document.documentElement.style.setProperty('--my-end-width', '100%');
    }

  })
.catch((error) => {
  console.error("Error fetching cart data:", error);
});
}

function findKeyByVariantId(cartItems, variantId) {
  const item = cartItems.find(i => i.variant_id === variantId);
  return item ? item.key : null;
}

function freeGift() {
  console.log('RUN FREE GIFT');
  fetch("/cart.js")
  .then((response) => response.json())
  .then((cart) => { 
    const GIFT_VARIANT_ID = window.FREE_GIFT_VARIANT_ID;
    const ENABLE_GIFT_CART_WITH_PROGRESS_BAR = window.ENABLE_GIFT_CART_WITH_PROGRESS_BAR;
    const reloadFlag = "free_gift_added";
    const itemCarts = cart.items;
    let hasGift = itemCarts.find((item) => item.id === GIFT_VARIANT_ID);
    let gift_threshold =  100;
    let convert_threshold =  parseInt(gift_threshold*100);

    if(ENABLE_GIFT_CART_WITH_PROGRESS_BAR){
    if (cart.items_subtotal_price > convert_threshold && hasGift == undefined) {
      console.log("Added gift to the cart");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: GIFT_VARIANT_ID,
          quantity: 1,
        }),
      })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then((data) => {
        const item = data;
        const itemHTML = `
                          <li class="ajaxcart__product" data-id="${item.id}" data-product_id="${item.product_id}">
                            <div class="ajaxcart row" data-id="${item.id}">
                              <div class="cart-item-loading"></div>
                              <div class="item_img">
                                <a href="${item.url}" class="ajaxcart__product-image">
                                  <img src="${item.image}" alt="${item.title}">
                                </a>
                              </div>
                              <div class="details">
                                <h6>
                                  <a href="${item.url}" class="ajaxcart__product-name">${item.title}</a>
                                </h6>
                                <div class="item-desc ajaxcart-product__details">
                                  <div class="item_dtl" data-id="${item.id}">
                                    <div class="pricing">
                                      <span class="ajaxcart__price"><span class="money">$${item.presentment_price.toFixed(2)}</span></span>
                                    </div>
                                  </div>
                                <div class="ajaxcart__qty product-item-caption-qty">
                                FREE GIFT
                                </div>
                                </div>
                              </div>
                            </div>
                          </li>
        `;
        document.querySelector('.ajaxcart__inner')?.insertAdjacentHTML('beforeend', itemHTML);
        localStorage.setItem(reloadFlag, "true");
        updateMainCartOnPage();
        $("#CartCount .CartCount").html(parseInt(cart.item_count + 1));
      }) 
      .catch((err) => {
        console.error("❌ Lỗi khi thêm vào giỏ:", err);
      });
    }
    if ((cart.items_subtotal_price > convert_threshold && hasGift) || (cart.items_subtotal_price < convert_threshold && hasGift == undefined)) {
      updateMainCartOnPage();
    }

    if(cart.items_subtotal_price < convert_threshold && hasGift){
      console.log(GIFT_VARIANT_ID);
      console.log("Remove and hide item on the cart");
      $("#CartCount .CartCount").html(parseInt(cart.item_count - 1));
      const giftElement = document.querySelector(`.cart-item[data-id="${GIFT_VARIANT_ID}"]`);
      if (giftElement) {
        giftElement.classList.add('hidden');
        
        // Lấy line number từ thuộc tính data-line của phần tử
        const giftLine = giftElement.getAttribute('data-line');
        console.log(giftLine);
        // Gọi API để xóa sản phẩm quà tặng
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: giftLine,
            quantity: 0
          })
        })
        .then(response => response.json())
        .then(cart => {
          console.log("Đã xóa sản phẩm quà tặng");
          updateMainCartOnPage();
        })
        .catch(error => {
          console.error("Lỗi khi xóa sản phẩm quà tặng:", error);
        });
      } else{
        updateMainCartOnPage();
      }
    }
 
    if(cart.items_subtotal_price < convert_threshold){
      const last_threshold =  convert_threshold - parseInt(cart.items_subtotal_price);
      $('.title__success').hide();
      $('.title__left, .title__right').removeClass('is-hidden').show();
      const priceInDollars = (last_threshold / 100).toFixed(2);
      const formattedPrice = `$${priceInDollars}`;
      $('.title__right-price').html(formattedPrice);
      console.log('formattedPrice' + formattedPrice);
      // Calculate progress percentage and update CSS variable
      const progressPercentage = (cart.items_subtotal_price / convert_threshold) * 100;
      document.documentElement.style.setProperty('--my-end-width', `${progressPercentage}%`);
    }else{
      $('.title__success').show();
      $('.title__left, .title__right').hide();
      document.documentElement.style.setProperty('--my-end-width', '100%');
    }
  }else{
    const giftElement = document.querySelector(`.cart-item[data-id="${GIFT_VARIANT_ID}"]`);
      if (giftElement) {
        giftElement.classList.add('hidden');
        const giftLine = giftElement.getAttribute('data-line');
        console.log(giftLine);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: giftLine,
            quantity: 0
          })
        })
        .then(response => response.json())
        .then(cart => {
          console.log("Remove gift from the cart");
          updateMainCartOnPage();
        })
        .catch(error => {
          console.error("Error remove gift from the cart:", error);
        });
      } else{
        updateMainCartOnPage();
      }
  }
  })
.catch((error) => {
  console.error("Error fetching cart data:", error);
});
}


function updateMainCartOnPage() {
	fetch('/cart')
	.then((response) => response.text())
	.then((html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newCartHTML = doc.querySelector('.cart_table');
		const cartItemsContainer = document.querySelector('.cart_table');
		if (cartItemsContainer) {
      $(".se-pre-con").hide()
			cartItemsContainer.innerHTML = newCartHTML.outerHTML;
		}
	})
	.catch((error) => {
		console.error('Error updating main cart:', error);
	});
}

function updateMainCart() {
	fetch('/cart?view=item')
	.then((response) => response.text())
	.then((html) => {
		const cartItemsContainer = document.querySelector('.js-cart-item');
		if (cartItemsContainer) {
			cartItemsContainer.innerHTML = html;
		}
	})
	.catch((error) => {
		console.error('Error updating main cart:', error);
	});
}

function updateDiscountCart() {
	fetch('/cart?view=discount')
	.then((response) => response.text())
	.then((response) => {
    $('.discounts').html(response);
	})
	.catch((error) => {
		console.error('Error updating main cart:', error);
	});
}

function updateDiscountCartItems(id) {
  fetch('/cart?view=discount-items')
  .then((response) => response.text())
  .then((response) => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(response, "text/html"); 
    let items = doc.querySelectorAll('.item_dtl');
    items.forEach(item => console.log(item.getAttribute("data-id")));
    let targetItem = Array.from(items).find(item => Number(item.getAttribute("data-id").trim()) === id);
    if(targetItem){
      let existingItem = document.querySelector(`.item_dtl[data-id="${id}"]`);
      existingItem.innerHTML = targetItem.innerHTML;
    }
  })
  .catch((error) => {
    console.error('Error updating main cart:', error);
  });
}

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    updateMainCart();
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(id, quantity, callback, el) {
  $.post('/cart/change.json', {
    quantity: quantity,
    id: id
  }).done(function(cart) {
    if (el.context.classList.contains('ajaxcart__qty-adjust') || el.context.classList.contains('ajaxcart__qty-remove')) {
     if ((typeof callback) === 'function') {
        $('.ajaxcart__product.selected').addClass('done');
        $('.ajaxcart__product.active').addClass('finish');
        $('.qty-error').remove();
        setTimeout(function() {
          $('.ajaxcart__product').removeClass('selected done active finish');
        }, 500);
        $("#CartCount .CartCount").html(cart.item_count);
        if (cart.item_count == 0) {
          let gift_threshold =  100;
          let convert_threshold =  parseInt(gift_threshold*100);
          const last_threshold =  convert_threshold - parseInt(cart.items_subtotal_price);
          $('.title__success').hide();
          $('.title__left, .title__right').removeClass('is-hidden').show();
          const priceInDollars = (last_threshold / 100).toFixed(2);
          const formattedPrice = `$${priceInDollars}`;
          $('.title__right-price').html(formattedPrice);
          // Calculate progress percentage and update CSS variable
          const progressPercentage = (cart.items_subtotal_price / convert_threshold) * 100;
          document.documentElement.style.setProperty('--my-end-width', `${progressPercentage}%`);
          $("#CartContainer").empty();
          $("#CartContainer").append('<p class="cart-content"> <span>No Products in your Cart.</span> <a class="dt-sc-btn" href="/collections/all">Continue Shopping</a></p>');
        } else {
          let getPriceAdded = "";
          updateDiscountCartItems(id);    
          updateDiscountCart();
          $(".cart-original-total").html(Shopify.formatMoney(cart.items_subtotal_price));
          freeGiftCartDrawer();
        }
      }
      else { 
        ShopifyAPI.onCartUpdate(cart);
      }
    }else{
      freeGift();
    }
  }).fail(function(jqXHR, textStatus, errorThrown) {
    $('.ajaxcart__product').removeClass('active');
    $('.ajaxcart__product').removeClass('selected');
    $('.qty-error').remove();
    if ($('[data-id="' + id + '"]').find(".qty-error").length == 0) {
      var addErrorMessage = $('[data-id="' + id + '"]').find(".ajaxcart-product__details"); 
      addErrorMessage.after('<div class="errors qty-error">'+ jqXHR.responseJSON.errors +'</div>')
    }
  });
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : 'CartCount',
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {

      evt.preventDefault();
      // Add class to be styled if desired
      // console.log("form selected");
      // console.log(evt.target);
      // console.log("button ATC selected");
      // console.log($(evt.target).find(".dT_AddToCart"));
      $(evt.target).find(".dT_AddToCart").addClass('loading');
      $(evt.target).find(".dT_AddToCart").prop('disabled', true);
      // $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (evt, product) {
    $(evt.target).find(".dT_AddToCart").removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus, evt) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $(evt.target).find(".dT_AddToCart").removeClass('is-adding is-added');
    if (!!data.message) {
      if (data.status == 422) {
        var $addButtoncontainer = $formContainer.find('.add-to-cart-group');
        var $inventoryQuantity = $addButtoncontainer.data('inventory-quantity');
        console.log("4: ", $inventoryQuantity)
        $addButtoncontainer.before('<div class="errors qty-error">'+ `Oops! We only have `+ $inventoryQuantity + ` items in stock for this product. Please adjust your quantity and try again.` +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function(cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="cart-content"> <span>No Products in your Cart.</span> <a class="dt-sc-btn" href="/collections/all">Continue Shopping</a></p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $('#CartTemplate').html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      var prodImg;
      if (cartItem.image !== null) {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_medium$1')
          .replace('http:', '');
      } else {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount =
            cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[
            discount
          ].formattedAmount = Shopify.formatMoney(
            amount,
            settings.moneyFormat
          );
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount =
            cart.cart_level_discount_applications[cartDiscount]
              .total_allocated_amount;
          cart.cart_level_discount_applications[
            cartDiscount
          ].formattedAmount = Shopify.formatMoney(
            cartAmount,
            settings.moneyFormat
          );
          var cartAmountTitle = cart.cart_level_discount_applications[cartDiscount].title;
          cart.cart_level_discount_applications[
            cartDiscount
          ].title = cartAmountTitle
        }
      }
      console.log("cartItem");
      console.log(cartItem);
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        itemProductID: cartItem.product_id,
        price: Shopify.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
        ),
        discountedPrice: Shopify.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied:
          cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor,
        id: cartItem.id
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      subTotalPrice: Shopify.formatMoney(
        cart.items_subtotal_price,
        settings.moneyFormat
      ),
      totalPrice: Shopify.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ),
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
        cart.cart_level_discount_applications.length === 0 ? false : true,
      cartTotalSavings: cart.cart_level_discount_applications.length === 0 && cart.total_discount > 0
    };

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);

     if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.off('click', '.ajaxcart__qty-adjust').on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          id = $el.data('id'),
          line = parseInt($el.attr('data-line')),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
        $qtySelector.val(qty);
      } else {
        qty -= 1;
        $qtySelector.val(qty);
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
   
        $el.closest('.ajaxcart__product').addClass('active');
        updateQuantity(id, line, qty, $el);
    });

    $body.off('click', '.qty-cartpage').on('click', '.qty-cartpage', function() {
      var $el = $(this),
          id = $el.data('id'),
          line = parseInt($el.attr('data-line')),
          $qtySelector = $el.siblings('.cart-number'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('qtyplus1')) {
        qty += 1;
        $qtySelector.val(qty);
      } else {
        qty -= 1;
        $qtySelector.val(qty);
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
     $(".se-pre-con").fadeIn("slow");
        updateQuantity(id, line, qty, $el);
    });

     // Add or remove from the quantity
     $body.off('click', '.cart__remove').on('click', '.cart__remove', function() {
        //get id and line product
        var id = $(this).data('id'),
         line = $(this).data('data-line'),
         $el =  $(this),
         qty = 0;
        $el.closest('.ajaxcart__product').addClass('active');
        $(".se-pre-con").fadeIn("slow");
        updateQuantity(id, line, qty, $el);
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove', function() {
        //get id and line product
        var id = $(this).data('id'),
         line = $(this).data('data-line'),
         $el =  $(this),
         qty = 0;
        $el.closest('.ajaxcart__product').addClass('active');
        updateQuantity(id, line, qty, $el);
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          id = $el.data('id'),
          line = parseInt($el.attr('data-line')),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(id, line, qty, $el);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(id, line, qty, el) {
      isUpdating = true; 
      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-id="' + id + '"]').addClass('is-loading');

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(id, qty, adjustCartCallback, el);
        if (qty === 0) {
          $row.parent().addClass('is-removed');
          setTimeout(function() {
            el.closest('.ajaxcart__product').remove();
          }, 800)
        }
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };



  return module;

}(ajaxCart || {}, jQuery));